import { Box } from '@grupoboticario/flora-react'
import { VideoShowcase } from 'src/@interfaces'
import {
  PlayIcon,
  Thumbnail,
  ThumbnailContainer,
  ThumbnailOverlay,
  VideoTitle,
} from './VideoScrollArea.styles'

interface VideoCardProps {
  video: VideoShowcase
  onClick: () => void
}

export const VideoCard = ({ video, onClick }: VideoCardProps) => {
  return (
    <ThumbnailContainer
      role="button"
      onClick={onClick}
      label={`Abrir vídeo do produto ${video.name}`}
    >
      <Box css={{ position: 'relative', marginBottom: '$2' }}>
        <Thumbnail
          src={video.thumbnail}
          alt={video.name}
        />
        <ThumbnailOverlay />
        <PlayIcon
          size="24"
          color="$backgroundPrimary"
        />
      </Box>
      <VideoTitle
        fontSize="bodySmallShort"
        fontWeight="medium"
      >
        {video.name}
      </VideoTitle>
    </ThumbnailContainer>
  )
}
